import { EditorModes, PcbNodeTypes, ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../types";
export class FloatingCopperValidator {
    reviewType = ReviewType.DesignRuleCheckFloatingCopper;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    async checkForProblems({ pcbLayoutNodes, pcbConnectivityGraphPromise }) {
        if (!pcbConnectivityGraphPromise)
            throw new Error("Missing pcbConnectivityGraphPromise in inputs");
        const pcbConnectivityGraph = await pcbConnectivityGraphPromise;
        const connectedComponents = pcbConnectivityGraph.getConnectedComponents();
        if (!connectedComponents) {
            // TODO: We should probably return a loading state here
            return { error: false, problemTypeKey: this.problemTypeKey, foundProblems: [] };
        }
        const connectedComponentsWithProblems = connectedComponents
            .map((cc) => cc.map((graphNodeUid) => {
            const attributes = pcbConnectivityGraph.getNodeAttributes(graphNodeUid);
            const nodeUid = attributes ? attributes?.nodeUid : graphNodeUid;
            const nodeType = pcbLayoutNodes[nodeUid]?.type;
            return { nodeUid, nodeType, graphNodeUid, attributes };
        }))
            .filter((cc) => {
            // We don't consider isolated pads as floating copper
            const isConnected = cc.some((node) => node.nodeType === PcbNodeTypes.pad);
            return !isConnected;
        }) ?? [];
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: connectedComponentsWithProblems.map((cc) => ({
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${cc.map((n) => n.graphNodeUid).join("+")}`,
                affectedItems: cc.map((node) => node.nodeType === PcbNodeTypes.fill && node.attributes
                    ? {
                        type: "pcbLayoutNode",
                        uid: node.graphNodeUid,
                        itemLabel: "Copper Fill Island",
                        boundingBox: {
                            minX: node.attributes.minX,
                            minY: node.attributes.minY,
                            maxX: node.attributes.maxX,
                            maxY: node.attributes.maxY,
                        },
                    }
                    : { type: "pcbLayoutNode", uid: node.nodeUid }),
                affectedViews: [EditorModes.pcb],
            })),
        };
    }
}
//# sourceMappingURL=FloatingCopperValidator.js.map